import Cookies from 'js-cookie';

export function setDismissedPopup(dismissedPopup) {
  Cookies.set('dismissedPopup', Boolean(dismissedPopup), {path: '/'});
}

export function getDismissedPopup() {
  return Cookies.get('dismissedPopup');
}
